module.exports = __webpack_public_path__ + "static/media/excel.e386a597.svg";